import React, { useState } from 'react'
import Preloader from '../components/Preloader'
import Footer from '../components/Footer';
import ScrollReveal from '../components/ScrollReveal';
import Header from '../components/Header';
import { FaChevronDown, FaChevronUp, FaTimes, FaCheckCircle, FaMoneyBillWave } from 'react-icons/fa';

const businessRequirements = [
    "Valid National Identification (Ghana Card).",
    "Business Registration Documents (Certificate of Incorporation/Commencement).",
    "Six (6) months' bank or mobile money statement.",
    "One (1) recent passport-sized photographs.",
    "Proof of Business Location and Residence (Utility Bill or Sketch).",
    "Completed and signed Loan Application Form."
];

const businessFaqs = [
    {
        question: "Who is Rapid Cash designed for?",
        answer: "Rapid Cash is tailored for traders and shop owners needing quick working capital to restock or expand."
    },
    {
        question: "What is the repayment schedule?",
        answer: "We offer flexible repayment terms including daily, weekly, or monthly options to align with your business cash flow."
    },
    {
        question: "How fast is the processing?",
        answer: "We understand business needs are urgent. Applications are processed and disbursed within 24-48 hours upon submission of all requirements."
    },
    {
        question: "Do I need a guarantor?",
        answer: "A guarantor may be required depending on the loan amount and your credit assessment."
    }
];

const BusinessLoans = () => {
    const [showRequirements, setShowRequirements] = useState(false);
    const [activeFaq, setActiveFaq] = useState(null);

    const toggleFaq = (index) => {
        setActiveFaq(activeFaq === index ? null : index);
    };

    return (
        <div className='font-nixie-one bg-white min-h-screen text-gray-800'>
            <Header />
            <Preloader />
            <main>
                {/* Hero Section */}
                <section className="relative h-[40vh] md:h-[50vh] bg-cover bg-center" style={{ backgroundImage: "url('/assets/bizloan.jpg')" }}>
                    <div className="absolute inset-0 bg-blue-900/60 flex items-center justify-center">
                        <ScrollReveal animationClass="animate-fade-up" threshold={0.1} delay={200}>
                            <div className="text-center text-white px-4">
                                <h1 className="text-2xl md:text-3xl font-bold mb-4 capitalize tracking-wide">Business Loans - Rapid Cash</h1>
                                <p className="text-sm md:text-sm max-w-2xl mx-auto font-light">
                                    Empowering traders and businesses with quick access to working capital.
                                </p>
                            </div>
                        </ScrollReveal>
                    </div>
                </section>

                {/* Content Section */}
                <section className="py-16 px-4 container mx-auto max-w-5xl">
                    <div className="grid md:grid-cols-2 gap-12 items-center mb-20">
                        <ScrollReveal animationClass="animate-slide-left" threshold={0.1}>
                            <div>
                                <div className="flex items-center gap-2 mb-4 text-blue-600">
                                    <FaMoneyBillWave className="text-2xl" />
                                    <span className="font-bold uppercase tracking-wider text-sm">Business Growth</span>
                                </div>
                                <h2 className="text-2xl font-bold text-gray-900 mb-6">Boost Your Business Capital</h2>
                                <p className="text-gray-600 font-semibold text-sm leading-relaxed mb-8 text-justify">
                                    Our "Rapid Cash" business loan is designed to support the growth of your enterprise. Whether you need to restock inventory, expand your shop, or manage operational costs, we provide the financial backing you need with speed and convenience.
                                </p>
                                <div className='flex flex-col lg:flex-row gap-6 items-start'>
                                    <button
                                    onClick={() => setShowRequirements(true)}
                                    className="bg-blue-600 hover:bg-blue-700 text-white text-sm font-semibold py-3 px-8 rounded-lg transition-all duration-300 shadow-md hover:shadow-lg flex items-center gap-2"
                                >
                                    View Requirements
                                </button>
                                 <button
                                    className="bg-blue-600 hover:bg-blue-700 text-white text-sm capitalize font-semibold py-3 px-8 rounded-lg transition-all duration-300 shadow-md hover:shadow-lg flex items-center gap-2"
                                >
                                    <a href='/contactus'>apply now</a>
                                </button>
                                </div>
                            </div>
                        </ScrollReveal>
                        <ScrollReveal animationClass="animate-fade-up" threshold={0.1} delay={200}>
                            <div className="rounded-2xl overflow-hidden shadow-xl h-80 md:h-96 relative group">
                                <div className="absolute inset-0 bg-blue-900/10 group-hover:bg-transparent transition-colors duration-300"></div>
                                <img src="/assets/mainlogo.jpg" alt="Business Loan" className="w-full h-full object-cover transform group-hover:scale-105 transition-transform duration-500" loading='lazy'/>
                                <div className="absolute inset-0 bg-gradient-to-t from-black/30 to-transparent"></div>
                            </div>
                        </ScrollReveal>
                    </div>

                    {/* FAQ Accordion */}
                    <ScrollReveal animationClass="animate-fade-up" threshold={0.1}>
                        <div className="bg-gray-50 rounded-2xl p-6 md:p-12 border border-gray-100">
                            <h3 className="text-2xl font-bold text-center text-blue-900 mb-8">Frequently Asked Questions</h3>
                            <div className="space-y-4 max-w-3xl mx-auto">
                                {businessFaqs.map((faq, index) => (
                                    <div key={index} className="bg-white rounded-lg shadow-sm border border-gray-200 overflow-hidden">
                                        <button
                                            className="w-full px-6 py-4 text-left flex justify-between items-center focus:outline-none hover:bg-gray-50 transition-colors"
                                            onClick={() => toggleFaq(index)}
                                        >
                                            <span className="font-semibold text-gray-800 text-sm md:text-sm">{faq.question}</span>
                                            <span className={`text-blue-600 transition-transform duration-300 ${activeFaq === index ? 'rotate-180' : ''}`}>
                                                {activeFaq === index ? <FaChevronUp /> : <FaChevronDown />}
                                            </span>
                                        </button>
                                        <div
                                            className={`transition-all duration-300 ease-in-out overflow-hidden ${activeFaq === index ? 'max-h-48 opacity-100' : 'max-h-0 opacity-0'}`}
                                        >
                                            <div className="px-6 pb-5 text-gray-600 text-sm font-semibold leading-relaxed border-t border-gray-100 pt-2">
                                                {faq.answer}
                                            </div>
                                        </div>
                                    </div>
                                ))}
                            </div>
                        </div>
                    </ScrollReveal>
                </section>

                {/* Requirements Modal */}
                {showRequirements && (
                    <div className="fixed inset-0 z-[100] flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm transition-opacity duration-300">
                        <div className="bg-white rounded-2xl shadow-2xl w-full max-w-lg overflow-hidden animate-fade-up">
                            <div className="bg-blue-900 p-5 flex justify-between items-center">
                                <h3 className="text-lg font-bold text-white flex items-center gap-2">
                                    <FaCheckCircle /> Business Loan Requirements
                                </h3>
                                <button onClick={() => setShowRequirements(false)} className="text-white hover:text-gray-200 transition-colors focus:outline-none">
                                    <FaTimes size={20} />
                                </button>
                            </div>
                            <div className="p-6 md:p-8 max-h-[70vh] overflow-y-auto">
                                <ul className="space-y-4">
                                    {businessRequirements.map((req, index) => (
                                        <li key={index} className="flex items-start gap-3 text-gray-700">
                                            <span className="mt-1.5 w-2 h-2 bg-blue-500 rounded-full flex-shrink-0"></span>
                                            <span className="text-sm font-semibold leading-relaxed">{req}</span>
                                        </li>
                                    ))}
                                </ul>
                                <div className="mt-8 pt-4 border-t border-gray-100 text-center">
                                    <button
                                        onClick={() => setShowRequirements(false)}
                                        className="bg-gray-100 hover:bg-gray-200 text-gray-800 font-semibold py-2 px-8 rounded-full transition-colors text-sm"
                                    >
                                        Close
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                )}
            </main>
            <Footer />
        </div>
    )
}

export default BusinessLoans
